import { computed } from '@angular/core';
import { signalStoreFeature, type, withComputed, withState } from '@ngrx/signals';
import { EntityId, EntityState } from '@ngrx/signals/entities';

export interface SelectedEntityState {
  selectedEntityId: EntityId | null;
}
export interface SelectedEntitiesState {
  selectedEntityIds: EntityId[] | null;
}

export function withSelectedEntity<Entity>() {
  return signalStoreFeature(
    { state: type<EntityState<Entity>>() },
    withState<SelectedEntityState>({ selectedEntityId: null }),
    withComputed(({ entityMap, selectedEntityId }) => ({
      selectedEntity: computed(() => {
        const selectedId = selectedEntityId();
        return selectedId ? entityMap()[selectedId] : null;
      }),
    })),
  );
}

export function withSelectedEntities<Entity>() {
  return signalStoreFeature(
    { state: type<EntityState<Entity>>() },
    withState<SelectedEntitiesState>({ selectedEntityIds: [] }),
    withComputed(({ entityMap, selectedEntityIds }) => ({
      selectedEntities: computed(() => {
        const selectedIds = selectedEntityIds();
        return selectedIds.map((id) => entityMap()[id]);
      }),
    })),
  );
}

export function setSelectedEntityId(id: number): SelectedEntityState {
  return { selectedEntityId: id };
}

export function setSelectedEntityIds(ids: number[]): SelectedEntitiesState {
  return { selectedEntityIds: ids };
}
